import { Component, OnInit } from '@angular/core';
import { DataService } from 'src/app/services/data.service';

@Component({
    selector: 'app-smblockschecker',
    templateUrl: './smblockschecker.component.html',
    styleUrls: ['./smblockschecker.component.scss'],
    standalone: false
})
export class SmblockscheckerComponent implements OnInit {

  constructor(public data: DataService) { }

  ngOnInit() {}

  labels(input: any) {
    return this.data.labels(input, 'SmblockscheckerComponent');
  }

}
